$(window).load(function(){
	matchHeight();
    product_carousel();
    testimonial_carousel();
});
$(document).ready(function(){
	product_carousel();
    matchHeight();
    testimonial_carousel();
});

/*
	Variable Functions ==========================================================
*/
function product_carousel(){
	jQuery('.product-carousel').owlCarousel({
		loop:true,
		nav: true,
		navText: ["<i class='fa-solid fa-arrow-left-long'></i>", "<i class='fa-solid fa-arrow-right-long'></i>"],
		responsiveClass:true,
		autoplay:true,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		responsive:{

			0:{

				items:1,

			},
			600:{

				items:2,

			},
			1000:{

				items:3,
			}
		}
	})
}

function testimonial_carousel(){
	jQuery('.testimonial-carousel').owlCarousel({
		loop:true,
		nav: true,
		navText: ["<i class='fa fa-long-arrow-left'></i>", "<i class='fa fa-long-arrow-right'></i>"],
		responsiveClass:true,
		autoplay:true,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		responsive:{

			0:{

				items:1,

			},
			600:{

				items:1,

			},
			1000:{

				items:1,
			}
		}
	})
}


function matchHeight() {
  console.log("matchHeightisWorking");
  jQuery('.product-card__title').matchHeight();
  jQuery('.price').matchHeight();
  jQuery('.product-card__image-with-placeholder-wrapper').matchHeight();
  jQuery('.grid-view-item .product-card .product-card__title').matchHeight();
  jQuery('.match-me').matchHeight();
  jQuery('.matchHeight').matchHeight();
  jQuery('.price .price--listing .price--on-sale ').matchHeight();
  jQuery('.grid-view-item ').matchHeight();
  jQuery('.article__grid-image-wrapper ').matchHeight();
  jQuery('.article__grid-image ').matchHeight();
  jQuery('.article__title ').matchHeight();
  
  jQuery('.card__heading ').matchHeight();
}

//Flos change
$(function() { // Shorthand for $(document).ready()
  console.log("Scossa Redirect Script (jQuery): Initializing.");

  const flosCollectionPath = "/collections/flos";
  const generalRedirectUrl = "https://scossa.co.uk/pages/meet-flos";
  const menuSpecificFlosRedirectUrl = "https://scossa.co.uk/collections/clearance?filter.v.price.gte=&filter.v.price.lte=&filter.p.vendor=Flos&sort_by=best-selling";

  // This function is only for redirecting if a user lands DIRECTLY on /collections/flos
  function handleGeneralFlosRedirect() {
    if (window.location.pathname === flosCollectionPath) {
      if (window.location.href !== menuSpecificFlosRedirectUrl) {
        console.log("Scossa Redirect Script (jQuery): (Landed on /collections/flos) Pathname matches. Redirecting to general URL:", generalRedirectUrl);
        window.location.replace(generalRedirectUrl);
      } else {
        console.log("Scossa Redirect Script (jQuery): (Landed on /collections/flos but href is menu-specific) No general redirect needed.");
      }
    }
  }

  // This function finds the menu link, changes its href, and adds our click handler
  function findAndPrepareFlosMenuLink() {
    const flosMenuLinkSelector = '.brands-menu a.gm-target[href="' + flosCollectionPath + '"]';
    var $flosMenuLink = $(flosMenuLinkSelector);

    if ($flosMenuLink.length > 0) {
      console.log("Scossa Redirect Script (jQuery): Flos menu link FOUND:", $flosMenuLink[0]); // Log the DOM element
      console.log("Scossa Redirect Script (jQuery): Original href was:", $flosMenuLink.attr('href'));

      $flosMenuLink.attr('href', menuSpecificFlosRedirectUrl);
      console.log("Scossa Redirect Script (jQuery): New href attribute set to:", $flosMenuLink.attr('href'));

      // Use .one() to ensure the handler runs only once per element, similar to {once: true}
      // Namespace the event for easier removal if needed, though .one() handles removal.
      $flosMenuLink.off('click.scossaFlos').one('click.scossaFlos', function(event) {
        console.log("Scossa Redirect Script (jQuery): FLOS MENU LINK CLICKED. Preventing default. Navigating to:", menuSpecificFlosRedirectUrl);
        event.preventDefault(); 
        event.stopPropagation(); 
        window.location.href = menuSpecificFlosRedirectUrl; 
      });
      
      console.log("Scossa Redirect Script (jQuery): Click listener configured for Flos menu link.");
      return true; // Indicate success
    }
    return false; // Link not found yet
  }

  // Try to handle the link immediately
  if (findAndPrepareFlosMenuLink()) {
    console.log("Scossa Redirect Script (jQuery): Flos menu link handled on initial check.");
  } else {
    // If not found, start polling
    console.log("Scossa Redirect Script (jQuery): Flos menu link not found on initial check. Setting up polling interval.");
    let attempts = 0;
    const maxAttempts = 50; // Poll for a maximum of ~10 seconds (50 * 200ms)
    const intervalCheck = setInterval(function() {
      attempts++;
      if (findAndPrepareFlosMenuLink()) {
        console.log("Scossa Redirect Script (jQuery): Flos menu link handled via polling. Clearing interval.");
        clearInterval(intervalCheck);
      } else if (attempts >= maxAttempts) {
        console.warn("Scossa Redirect Script (jQuery): Flos menu link not found after " + maxAttempts + " attempts. Stopping poll. The menu link might not be using the expected selector or not loading.");
        clearInterval(intervalCheck);
      }
    }, 200); // Check every 200 milliseconds
  }

  // This handles direct navigation to /collections/flos (e.g., from a search engine)
  handleGeneralFlosRedirect();

});












